import TYPES from '../actions/types';

const INITIAL_STATE = {
  cityOptions: null,
  addressOptions: null,
};

const selectOptionsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES.getCityOptions:
      return {
        ...state,
        cityOptions: action.payload,
      };

    case TYPES.getZipcodeOptions:
      return {
        ...state,
        addressOptions: action.payload,
      };

    default:
      return state;
  }
}


export default selectOptionsReducer;
